"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const winston = __importStar(require("winston"));
/** custom log levels */
const logLevels = {
    levels: {
        isolate: 0,
        error: 1,
        warn: 2,
        info: 3,
    },
    colors: {
        isolate: "blue",
        error: "red",
        warn: "yellow",
        info: "green",
    },
};
/** default values Console Transport */
const consoleTransportOptionsDefaults = {
    level: "info",
    silent: false,
};
/** default values File Transport */
const fileTransportOptionsDefaults = {
    level: "info",
    silent: false,
    filename: "./logs",
    maxSize: 1000000,
    maxFiles: 3,
    zippedArchive: false,
};
class Logger {
    /**
     * Class Constructor
     *
     * @param transportType - The type of transport we want to choose
     * @param transportOptions - (Optional) The transport options associated with transport type
     */
    constructor(transportType, transportOptions) {
        this.loggerOptions = {
            level: "info",
            levels: logLevels.levels,
            format: winston.format.json(),
            transports: [],
            exitOnError: true,
            silent: false,
        };
        switch (transportType) {
            case "console":
                this.transportOptions = Object.assign(Object.assign({}, consoleTransportOptionsDefaults), transportOptions);
                this.loggerOptions.transports = new winston.transports.Console(this.transportOptions);
                break;
            case "file":
                this.transportOptions = Object.assign(Object.assign({}, fileTransportOptionsDefaults), transportOptions);
                this.loggerOptions.transports = new winston.transports.File(this.transportOptions);
                break;
            default:
                throw new Error("Invalid option");
        }
        this.logger = winston.createLogger(this.loggerOptions);
        winston.addColors(logLevels.colors);
    }
    // public methods
    /**
     * Sets silent property of logger
     * @param val - Boolean value for silent property
     */
    setSilent(val) {
        this.logger.silent = val;
    }
    /**
     * gets value of silent property of logger
     * @returns value of silent property of logger {@link: this.logger.silent}
     */
    isSilent() {
        return this.logger.silent;
    }
    /** public logging functions */
    /**
     * logs a isolate level log
     * @param message - the message you want to log
     */
    isolate(message) {
        this.logger.log({ message, level: "isolate" });
    }
    /**
     * logs a error level log
     * @param message - the message you want to log
     */
    error(message) {
        this.logger.error(message);
    }
    /**
     * logs a wa rn level log
     * @param message - the message you want to log
     */
    warn(message) {
        this.logger.warn(message);
    }
    /**
     * logs a info level log
     * @param message - the message you want to log
     */
    info(message) {
        this.logger.info(message);
    }
    /**
     * logs a log at provided log level
     * @param logLevel - the log level at which to log the message
     * @param message - the message you want to log
     */
    log(logLevel, message) {
        this.logger.log({ message, level: logLevel });
    }
}
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map